import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-debug-form',
  templateUrl: './debug-form.component.html',
  styleUrls: ['./debug-form.component.scss'],
  standalone: false,
})
export class DebugFormComponent {
  @Input() form?: FormGroup;

  get debug() {
    return {
      formValid: this.form?.valid,
      ctrls: this.form
        ? getAllControls(this.form, (ctrl) => ({
            VALUE: ctrl.value,
            errors: ctrl.errors,
            valid: ctrl.valid,
            dirty: ctrl.dirty,
            disabled: ctrl.disabled,
          }))
        : [],
      formValue: this.form?.value,
      rawValue: this.form?.getRawValue(),
    };
  }
}

// to do recursive
export function getAllControls(grp: FormGroup, mapper?: (ctrl: AbstractControl) => any) {
  const ctrls: { [key: string]: any } = {};
  Object.keys(grp.controls).forEach((key) => {
    ctrls[key] = mapper ? mapper(grp.controls[key]) : grp.controls[key];
  });

  return ctrls;
}
